import { html } from 'lit';
import fsTypography from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { classMap } from 'lit-html/directives/class-map.js';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { nothing } from 'lit-html';
import { style } from './iconic-choose-vehicle-loan.style.js';
import { DebugService } from '../../../shared/services/debug.service.js';
import '../iconic-vehicle-loan-card/iconic-vehicle-loan-card.component.js';
import '../../../shared/modals/papr-limit/papr-limit-modal.component.js';
import { VehicleService } from '../../../services/vehicle.service.js';
import { RefiIconicChooseLoan } from '../../iconic-loan/iconic-choose-loan/iconic-choose-loan.component.js';
import { REFI_VEHICLE_LOAN_CONST } from '../../../shared/constants/app.constants.js';
import { POLICY_LIMITS_CONST } from '../../../shared/services/policy-limits.service.js';
import { tags } from '../../../shared/constants/tags.js';
import { LoanService } from '../../../services/loan.service.js';
// import { ApplicationService } from '../../../services/application.service.js';
import { stratum } from '../../../../constants/stratum.js';
import { ApplicationService } from '../../../services/application.service.js';
import '../../iconic-container/iconic-container.component.js';
import { VehicleAndLoanService } from '../../../services/vehicle-and-loan.service.js';

class RefiIconicChooseVehicleLoan extends RefiIconicChooseLoan {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicChooseVehicleLoan');
    this.vehicleAndLoanMatchList = [];
    this.selectedVehicle = {};
    this.isVehicleSelected = false;
    this.marketingOffer = ApplicationService.MarketingOffer;
    this.multiple = false;
  }

  static properties = {
    vehicleAndLoanMatchList: { type: Array, reflect: true },
  };

  static styles = [style, fsTypography];

  connectedCallback() {
    super.connectedCallback();
    LoanService.shouldCallCustomerLoans = false;
    this.resetTitle();
    this.multiple = this.vehicleAndLoanMatchList.length > 1;
    if (ApplicationService.isInAppDeclineDelayOn) {
      stratum.publishTag(
        TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH_2
      );
      stratum.publishTag(
        TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION_2
      );
    } else {
      stratum.publishTag(TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN);
      stratum.publishTag(
        TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH
      );
    }
    this.sendHostAppHeaderUpdates();
  }

  // override the parent class to prevent the wrong stratum tag
  firstUpdated() {}

  disconnectedCallback() {
    super.disconnectedCallback();
    this.debug.log('iconic vl disconnect');
    document.dispatchEvent(
      new CustomEvent('header-bottom-slot-color-change', {
        bubbles: true,
        composed: true,
        detail: { colored: false },
      })
    );
  }

  setSelectedVehicle(event) {
    const { vehicle } = event?.detail;
    this.debug.log('setting selected vehicle', vehicle);
    this.isVehicleSelected = false;
    this.debug.log('selectedVehicle', vehicle);
    this.selectedVehicle = vehicle;
    VehicleService.selectedVehicle = vehicle;
    this.isVehicleSelected = true;
  }

  goToChooseVehicle() {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(
      tags.vehicleAndLoan.changeVehicleOrLoan
    );
    stratum.publishTag(
      ApplicationService.isInAppDeclineDelayOn
        ? TagKey.LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK_2
        : TagKey.LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK
    );
    this.sendHostAppHeaderUpdates();
    this.dispatchEvent(
      new CustomEvent('next-step', {
        bubbles: true,
        composed: true,
        detail: false,
      })
    );
  }

  renderVehicleLoanCards() {
    const mapper = (vehLoan, i) => {
      this.debug.log('mapping', i);
      // set up selected
      return html`<refi-iconic-vehicle-loan-card
        .vehicle="${vehLoan.vehicle}"
        .loan="${vehLoan.loan}"
        .multiple="${this.vehicleAndLoanMatchList.length > 1}"
        vehicleAndLoanIndex="${i}"
        @selectVehicle="${this.setSelectedVehicle}"
        @selectLoan="${(e) => {
          this.setSelectedLoan(e, false);
          this.selectLoan(e);
        }}"
        hide-ineligibility="${ApplicationService.isInAppDeclineDelayOn
          ? ''
          : nothing}"
        .tagBalance="${ApplicationService.isInAppDeclineDelayOn}"
      ></refi-iconic-vehicle-loan-card>`;
    };
    let result = this.vehicleAndLoanMatchList?.map(mapper);
    if (this.vehicleAndLoanMatchList.length > 0) {
      result = html` <refi-track-pageview
          pagename="vehicle-loan"
        ></refi-track-pageview>
        <div
          class="${classMap({
            header:
              !ApplicationService.isInAppDeclineDelayOn && this.marketingOffer,
            'header-full':
              !ApplicationService.isInAppDeclineDelayOn && !this.marketingOffer,
          })}"
        >
          <div class="iconic-container">
            ${ApplicationService.isInAppDeclineDelayOn
              ? html`
                  <h1 class="inapp-decline-delay-header">
                    Confirm the vehicle and loan you want to refinance
                  </h1>
                `
              : html`
                  <h1 class="header-text">
                    Confirm the car you want to refinance
                  </h1>
                `}
            ${this.marketingOffer
              ? html`
                  <h2 class="marketing-offer">
                    Your new ${this.marketingOffer.annualPercentRate}% APR is
                    waiting!
                  </h2>
                `
              : ''}
          </div>
        </div>
        <refi-iconic-container
          returnButtonText="I want to refinance a different car"
          @return-cta-clicked=${this.goToChooseVehicle}
        >
          <div
            class="grid ${classMap({
              'grid-multiple': this.multiple,
            })}"
          >
            ${result}
          </div>
        </refi-iconic-container>`;
    }
    return result;
  }

  static isMatchEligible(match) {
    if (
      !(
        match.vehicle.ineligibleReasons &&
        match.vehicle.ineligibleReasons.length > 0 &&
        Number(match.vehicle.wholeSaleValue) === 0
      )
    ) {
      if (
        RefiIconicChooseVehicleLoan.isHighLtv(
          match.loan.currentBalance,
          match.vehicle.wholeSaleValue
        ) &&
        match.loan.ineligibleReasons.indexOf('HIGH_LTV') === -1
      ) {
        match.loan.ineligibleReasons.push('HIGH_LTV');
      }
      if (
        !RefiIconicChooseVehicleLoan.isHighLtv(
          match.loan.currentBalance,
          match.vehicle.wholeSaleValue
        ) &&
        match.loan.ineligibleReasons.indexOf('HIGH_LTV') !== -1
      ) {
        match.loan.ineligibleReasons.splice(
          match.loan.ineligibleReasons.indexOf('HIGH_LTV'),
          1
        );
      }
    }
    return (
      !(
        match.vehicle.ineligibleReasons &&
        match.vehicle.ineligibleReasons.length > 0
      ) &&
      !(match.loan.ineligibleReasons && match.loan.ineligibleReasons.length > 0)
    );
  }

  static isVehicleEligible(vehicle) {
    return !(vehicle.ineligibleReasons && vehicle.ineligibleReasons.length > 0);
  }

  static isLoanEligible(loan) {
    return !(loan.ineligibleReasons && loan.ineligibleReasons.length > 0);
  }

  static isHighLtv(currentBalance, wholeSaleValue) {
    return (
      Number(currentBalance) / Number(wholeSaleValue) >
      POLICY_LIMITS_CONST.MAX_LTV()
    );
  }

  calculateTitle() {
    if (!this.vehicleAndLoanMatchList) {
      return null;
    }
    const matchCount = this.vehicleAndLoanMatchList.length;
    const eMatchCount = this.eligibleMatchCount;
    // single match
    if (matchCount === 1) {
      const match = this.vehicleAndLoanMatchList[0];
      const matchedVehicle = match.vehicle;
      const matchedLoan = match.loan;
      if (
        RefiIconicChooseVehicleLoan.isLoanEligible(matchedLoan) &&
        RefiIconicChooseVehicleLoan.isVehicleEligible(matchedVehicle)
      ) {
        return 'Confirm the car you want to refinance.';
      }
      if (
        RefiIconicChooseVehicleLoan.isLoanEligible(matchedLoan) &&
        !RefiIconicChooseVehicleLoan.isVehicleEligible(matchedVehicle)
      ) {
        return "We were able to find your vehicle and loan, however this vehicle isn't eligible for refinancing.";
      }
      if (
        !RefiIconicChooseVehicleLoan.isLoanEligible(matchedLoan) &&
        RefiIconicChooseVehicleLoan.isVehicleEligible(matchedVehicle)
      ) {
        return "We were able to find your vehicle and loan, however this loan isn't eligible for refinancing.";
      }
      if (
        !RefiIconicChooseVehicleLoan.isLoanEligible(matchedLoan) &&
        !RefiIconicChooseVehicleLoan.isVehicleEligible(matchedVehicle)
      ) {
        return "We were able to find your vehicle and loan, however they're not eligible for refinancing.";
      }
    }
    // multiple matches
    // none eligible
    if (eMatchCount === 0) {
      return 'We found multiple matches for you, but none are eligible for refinancing.';
    }
    // some eligible
    if (eMatchCount > 0 && eMatchCount < matchCount) {
      return 'We found multiple matches for you. At least one is eligible for refinancing';
    }
    // all eligible
    if (eMatchCount === matchCount) {
      return 'We found multiple matches for you. Please confirm which you would like to refinance.';
    }
    return null;
  }

  resetTitle() {
    this.title = this.calculateTitle();
  }

  get eligibleMatchCount() {
    let count = 0;
    for (const match of this.vehicleAndLoanMatchList) {
      if (RefiIconicChooseVehicleLoan.isMatchEligible(match)) {
        count += 1;
      }
    }
    return count;
  }

  sendHostAppHeaderUpdates() {
    this.dispatchEvent(
      new CustomEvent('show-progress-bar', {
        detail: {
          displayBar: true,
        },
        composed: true,
        bubbles: true,
      })
    );
    this.debug.log('sending color event disconnect');
    this.dispatchEvent(
      new CustomEvent('header-bottom-slot-color-change', {
        bubbles: true,
        composed: true,
        detail: { colored: !ApplicationService.isInAppDeclineDelayOn },
      })
    );
  }

  determineNextPage() {
    if (ApplicationService.isInAppDeclineDelayOn) {
      this.debug.log(
        'InApp Decline Delay is on - checking for eligibility before submission'
      );
      if (
        VehicleAndLoanService.getInAppDeclineReason(
          this.vehicle,
          this.selectedLoan
        )
      ) {
        this.debug.log(
          'Vehicle and loan has in-app decline. Routing to ineligible page...'
        );
        this.dispatchEvent(
          new CustomEvent('delayed-decline', {
            bubbles: true,
            composed: true,
          })
        );
      } else {
        this.debug.log(
          'Vehicle and loan are eligible. Skipping ineligible page.'
        );
        this.dispatchEvent(
          new CustomEvent('go-to-review', {
            bubbles: true,
            composed: true,
          })
        );
      }
    } else {
      this.debug.log('route to review');
      this.dispatchEvent(
        new CustomEvent('go-to-review', {
          bubbles: true,
          composed: true,
        })
      );
    }
  }

  render() {
    this.debug.log('rendering');
    return html`
      <refi-papr-limit-modal
        id="refi-papr-limit"
        @continuePrequal="${this.goToNextStep}"
        @exitPrequal="${this.exitPrequal}"
      ></refi-papr-limit-modal>
      ${this.renderVehicleLoanCards()}
    `;
  }
}

customElements.define(
  'refi-iconic-choose-vehicle-loan',
  RefiIconicChooseVehicleLoan
);
